import { render, staticRenderFns } from "./MultiSliderPollAnswers.vue?vue&type=template&id=6aaa2586&"
import script from "./MultiSliderPollAnswers.vue?vue&type=script&lang=ts&"
export * from "./MultiSliderPollAnswers.vue?vue&type=script&lang=ts&"
import style0 from "./MultiSliderPollAnswers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports